import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ensureNamespaces } from '../../i18n';
import BrandLogo from '../shared/brandLogo/brandLogo';
import appStoreBadge from '../../images/landing/appstore_button.svg.webp';
import googlePlayBadge from '../../images/landing/google_play_button.svg.webp';
import { ANDROID_PLAY_STORE_URL, IOS_APP_STORE_URL } from '../../utils/storeUrls';
import { handleLandingAnchorClick } from '../../utils/landingAnchorScroll';

import {
  FooterBrandColumn,
  FooterCopyright,
  FooterDescription,
  FooterLink,
  FooterLinksColumn,
  FooterLinksList,
  FooterLogoCell,
  LandingContainer,
  LandingFooter,
  LandingFooterBottom,
  LandingFooterMain,
  StoreBadge,
  StoreBadgeLink,
  StoreBadgesRow,
  StoreButtons,
} from './landingPage.styles';

const FOOTER_LINKS = [
  { key: 'support', href: '/support', isRoute: true },
  { key: 'deleteAccount', href: '/delete-account', isRoute: true },
  { key: 'privacy', href: '/privacy-policy', isRoute: true },
  { key: 'terms', href: '/terms-of-service', isRoute: true },
];

export default function LandingFooterSection() {
  const navigate = useNavigate();
  const { t } = useTranslation('landing');
  const year = new Date().getFullYear();

  useEffect(() => {
    ensureNamespaces(['landing']);
  }, []);

  return (
    <LandingFooter>
      <LandingContainer>
        <LandingFooterMain>
          <FooterLogoCell>
            <Link to="/" aria-label="Healthy Pet home" style={{ textDecoration: 'none', color: 'inherit' }}>
              <BrandLogo size="md" align="start" />
            </Link>
          </FooterLogoCell>

          <FooterBrandColumn>
            <FooterDescription>{t('footer.description')}</FooterDescription>

            <StoreBadgesRow>
              <StoreButtons>
                <StoreBadgeLink
                  href={IOS_APP_STORE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="App Store"
                >
                  <StoreBadge src={appStoreBadge} alt="App Store" />
                </StoreBadgeLink>
                <StoreBadgeLink
                  href={ANDROID_PLAY_STORE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Google Play"
                >
                  <StoreBadge src={googlePlayBadge} alt="Google Play" />
                </StoreBadgeLink>
              </StoreButtons>
            </StoreBadgesRow>
          </FooterBrandColumn>

          <FooterLinksColumn>
            <FooterLinksList aria-label={t('footer.linksTitle')}>
              {FOOTER_LINKS.map(({ key, href, isRoute }) =>
                isRoute ? (
                  <FooterLink key={key} as={Link} to={href}>
                    {t(`footer.${key}`)}
                  </FooterLink>
                ) : (
                  <FooterLink
                    key={key}
                    href={href}
                    onClick={(event) => handleLandingAnchorClick(event, href, { navigate })}
                  >
                    {t(`footer.${key}`)}
                  </FooterLink>
                ),
              )}
            </FooterLinksList>
          </FooterLinksColumn>
        </LandingFooterMain>

        <LandingFooterBottom>
          <FooterCopyright>{t('footer.copyright', { year })}</FooterCopyright>
        </LandingFooterBottom>
      </LandingContainer>
    </LandingFooter>
  );
}
